import Layout from 'antd/lib/layout'
import './index.less'

export default Layout



// WEBPACK FOOTER //
// ./src/elements/layout/index.js